__turbopack_context__.v({
  "picture": "oXVqCa_picture",
  "picture__ai-marker--max-1023": "oXVqCa_picture__ai-marker--max-1023",
  "picture__ai-marker--max-767": "oXVqCa_picture__ai-marker--max-767",
  "picture__ai-marker--min-1024": "oXVqCa_picture__ai-marker--min-1024",
  "picture__ai-marker--min-768": "oXVqCa_picture__ai-marker--min-768",
  "picture__element": "oXVqCa_picture__element",
  "picture__element--full-width": "oXVqCa_picture__element--full-width",
  "picture__wrapper": "oXVqCa_picture__wrapper",
});
